import {LANGUAGE} from '@/common/utils/constants';

export const SEARCH_PAGE_TRANSLATIONS = {[LANGUAGE.en.short]: {
		filters: "Filters",
		unselectAll: 'Unselect all',
		noResults: 'No results found.',
		date: 'Date: All time',
		selectDateRange: 'Select a new date range',
		list: 'List',
		grid: 'Grid',
		removeAllFilters: "Remove all filters",
		searchInputPlaceHolder: 'Search throughout all stories’ content',
		closeFilters: 'Close Filters',
		openFilters: 'Open Filters',
		removeFilters: "Remove all",
		searchPlaceholder: "Search throughout all stories' content",
		searchPlaceholderMobile: "Search for Titles, Stories...",
		projectsMatch: "projects match your filters",
		subTechPractices: "Sub Tech Practices",
		subServiceLines: "Sub type of businesses",
		akkodisCountries: "Countries",
		certifications: "Certifications",
		toolsAndSystems: "Tools & Systems",
		confidentialities: "Confidentiality",
		latest: "Latest",
		mostVisited: "Popular",
		industries: "Industries",
		techPractices: "Tech practices",
		serviceLines: "Type of Business",
		locations: "Team location",
		tools: 'Tools',
		ftes: "FTEs",
		certificates: "Certifications",
		revenues: "Revenue",
		clientLocations: "Client Location",
		referenceOwners: "Reference Owners",
		companies: "Clients",
		businessContactManagers: "Business Managers",
		deliveryContactManagers: "Delivery Managers",
		filterPlaceholders: {
			location: "Search for location",
			clients: "Search for clients",
			tools: "Search for tools",
			certifications: "Search for certifications",
			owners: "Search for reference owners",
			industries: "Search for industries",
			techPractices: 'Search for tech practices',
			serviceLines: 'Search for type of businesses',
			managers: "Search for manager",
			mainClientPersonas: "Search for main client personas",
			globalOwners: "Search for owners",
			recognitions: "Search for recognitions",
		},
		recognitions: "Recognitions",
		mainClientPersonas: "Main Client Personas",
		globalOwners: "Owners",
		sort: {
			latest: 'latest',
			mostVisited: 'most visited'
		},
		statistics: {
			subTechPractices: 'Sub tech practices',
			subServiceLines: 'Sub type of business',
			akkodisCountries: 'countries',
			certifications: 'Certifications',
			toolsAndSystems: 'Tools & Systems',
			title: ' projects match your filters',
			publishedDateMessage: 'You have selected publication dates from',
			saved: 'Saved',
			filterBySavedProjects: 'Filter by saved projects',
			to: 'to',
			selectDates: 'Filter by publication date',
			datesAlreadyExist: 'The time period already exists.',
			days: {
				monday: 'Mon',
				tuesday: 'Tue',
				wednesday: 'Wed',
				thursday: 'Thu',
				friday: 'Fri',
				saturday: 'Sat',
				sunday: 'Sun'
			},
			months: {
				january: 'Jan',
				february: 'Feb',
				march: 'Mar',
				april: 'Apr',
				may: 'May',
				june: 'Jun',
				july: 'Jul',
				august: 'Aug',
				september: 'Sep',
				october: 'Oct',
				november: 'Nov',
				december: 'Dec'
			}
		},
		relevancy: 'Relevancy',
		clearAllFilters: 'Clear all filters',
		saved: 'Saved',
		draft: "Draft",
		deliveryLocation: "Delivery Location",
	},
	[LANGUAGE.de.short]: {
		filters: "Filter",
		unselectAll: 'Auswahl aufheben',
		noResults: 'Keine Ergebnisse gefunden.',
		date: 'Datum: Immer',
		selectDateRange: 'Wählen Sie einen neuen Datumsbereich',
		list: 'Liste',
		grid: 'Netz',
		removeAllFilters: "Alle Filter entfernen",
		searchInputPlaceHolder: 'Durchsuchen Sie den gesamten Inhalt der Story',
		closeFilters: 'Filter schließen',
		openFilters: 'Filter öffnen',
		removeFilters: "Alles entfernen",
		searchPlaceholder: "Suchen Sie nach Titeln, Inhalten von Geschichten und Testimonials.",
		searchPlaceholderMobile: "Suche nach Titeln, Geschichten...",
		projectsMatch: "Projekte entsprechen Ihren Filtern",
		subTechPractices: "Sub-Tech-Praktiken",
		subServiceLines: "Unterart des Geschäfts",
		akkodisCountries: "Länder",
		certifications: "Zertifizierungen",
		toolsAndSystems: "Tools & Systeme",
		confidentialities: "Vertraulichkeit",
		latest: "Neueste",
		mostVisited: "Beliebt",
		industries: "Branchen",
		techPractices: "Technische Praktiken",
		serviceLines: "Geschäftsart",
		locations: "Standort des Teams",
		tools: 'Werkzeug',
		ftes: "FTEs",
		revenues: "Einnahmen",
		clientLocations: "Kundenstandort",
		referenceOwners: "Referenzbesitzer",
		companies: "Kunden",
		businessContactManagers: "Unternehmensleiter",
		deliveryContactManagers: "Liefermanager",
		filterPlaceholders: {
			location: "Nach Standort suchen",
			clients: "Suche nach Kunden",
			tools: "Suchen Sie nach Werkzeugen",
			certifications: "Suche nach Zertifizierungen",
			owners: "Suche nach Referenzinhabern",
			industries: "Suche nach Branchen",
			techPractices: 'Suchen Sie nach technischen Praktiken',
			serviceLines: 'Suchen Sie nach Geschäftsart',
			managers: "Suche nach Manager",
			mainClientPersonas: "Suche nach Hauptkunden-Personas",
			globalOwners: "Nach Owners suchen",
			recognitions: "Suche nach Anerkennungen",
		},
		recognitions: "Anerkennungen",
		mainClientPersonas: "Hauptkunden-Personas",
		globalOwners: "Eigentümer",
		sort: {
			latest: 'neueste',
			mostVisited: 'meist besuchte'
		},
		statistics: {
			subTechPractices: 'Sub-Tech-Praktiken',
			subServiceLines: 'Unterart des Geschäfts',
			akkodisCountries: 'Länder',
			certifications: 'Zertifizierungen',
			toolsAndSystems: 'Werkzeuge & Systeme',
			title: ' projekte entsprechen Ihren Filtern',
			publishedDateMessage: 'Sie haben Veröffentlichungstermine ausgewählt aus',
			saved: 'Gespeichert',
			filterBySavedProjects: 'Filtern Sie nach gespeicherten Projekten',
			to: 'zu',
			selectDates: 'Filtern Sie nach Veröffentlichungsdatum',
			datesAlreadyExist: 'Der Zeitraum existiert bereits.',
			days: {
				monday: 'Mon',
				tuesday: 'Die',
				wednesday: 'Mit',
				thursday: 'Don',
				friday: 'Fre',
				saturday: 'Sam',
				sunday: 'Son'
			},
			months: {
				january: 'Jan',
				february: 'Feb',
				march: 'Mar',
				april: 'Apr',
				may: 'Mai',
				june: 'Jun',
				july: 'Jul',
				august: 'Aug',
				september: 'Sep',
				october: 'Okt',
				november: 'Nov',
				december: 'Dez'
			}
		},
		relevancy: 'Relevanz',
		clearAllFilters: 'Alle Filter löschen',
		saved: 'Gespeichert',
		draft: "Entwurf",
		deliveryLocation: "Lieferort",
	},
	[LANGUAGE.fr.short]: {
		filters: "Filtres",
		unselectAll: 'Désélectionner tout',
		noResults: 'Aucun résultat trouvé.',
		date: 'Date : Tout le temps',
		selectDateRange: 'Sélectionnez une nouvelle plage de dates',
		list: 'Liste',
		grid: 'Grille',
		removeAllFilters: "Supprimer tous les filtres",
		searchInputPlaceHolder: 'Rechercher dans le contenu de toutes les histoires',
		closeFilters: 'Fermer les filtres',
		openFilters: 'Ouvrir les filtres',
		removeFilters: "Enlever tout",
		searchPlaceholder: "Recherchez des titres, du contenu d'histoires et des témoignages.",
		searchPlaceholderMobile: "Rechercher des titres, des histoires...",
		projectsMatch: "Les projets correspondent à vos filtres",
		subTechPractices: "Pratiques de sous-technologie",
		subServiceLines: "Sous-type d'activité",
		akkodisCountries: "Des pays",
		certifications: "Certifications",
		toolsAndSystems: "Outils et systèmes",
		confidentialities: "Confidentialité",
		latest: "Dernier",
		mostVisited: "Populaire",
		industries: "Industries",
		techPractices: "Pratiques technologiques",
		serviceLines: "Type d'activité",
		locations: "Emplacement de l'équipe",
		tools: 'Outils',
		ftes: "FTEs",
		revenues: "Revenu",
		clientLocations: "Emplacement du client",
		referenceOwners: "Propriétaires de référence",
		companies: "Clients",
		businessContactManagers: "Business Managers",
		deliveryContactManagers: "Delivery Managers",
		filterPlaceholders: {
			location: "Rechercher un lieu",
			clients: "Rechercher des clients",
			tools: "Rechercher des outils",
			certifications: "Rechercher des certifications",
			owners: "Rechercher des propriétaires de référence",
			industries: "Rechercher des secteurs d'activité",
			techPractices: 'Rechercher des pratiques technologiques',
			serviceLines: "Rechercher des type d'activité",
			managers: "Recherche de gérant",
			mainClientPersonas: "Rechercher des personas de clients principaux",
			globalOwners: "Rechercher des propriétaires",
			recognitions: "Rechercher des reconnaissances",
		},
		recognitions: "Reconnaissances",
		mainClientPersonas: "Personas de clients principaux",
		globalOwners: "Propriétaire",
		sort: {
			latest: 'dernier',
			mostVisited: 'le plus visité'
		},
		statistics: {
			subTechPractices: 'Pratiques de sous-technologie',
			subServiceLines: "Sous-type d'activité",
			akkodisCountries: 'des pays',
			certifications: 'Certificats',
			toolsAndSystems: 'Outils et systèmes',
			title: ' les projets correspondent à vos filtres',
			publishedDateMessage: 'Vous avez sélectionné des dates de publication à partir de',
			saved: 'Enregistré',
			filterBySavedProjects: 'Filtrer par projets enregistrés',
			to: 'à',
			selectDates: 'Filtrer par date de publication',
			datesAlreadyExist: 'La période existe déjà.',
			days: {
				monday: 'Lun',
				tuesday: 'Mar',
				wednesday: 'Mer',
				thursday: 'Jeu',
				friday: 'Ven',
				saturday: 'Sam',
				sunday: 'Dim'
			},
			months: {
				january: 'Jan',
				february: 'Fév',
				march: 'Mar',
				april: 'Avr',
				may: 'Mai',
				june: 'Jui',
				july: 'Jui',
				august: 'Aoû',
				september: 'Sep',
				october: 'Oct',
				november: 'Nov',
				december: 'Déc'
			}
		},
		relevancy: 'Pertinence',
		clearAllFilters: 'Effacer tous les filtres',
		saved: 'Enregistré',
		draft: "Brouillon",
		deliveryLocation: "Lieu de livraison",
	},
	[LANGUAGE.it.short]: {
		filters: "Filtri",
		unselectAll: 'Deseleziona tutto',
		noResults: 'Nessun risultato trovato.',
		date: 'Data: Sempre',
		selectDateRange: 'Seleziona un nuovo intervallo di date',
		list: 'Lista',
		grid: 'Griglia',
		removeAllFilters: "Rimuovi tutti i filtri",
		searchInputPlaceHolder: 'Cerca in tutto il contenuto delle storie',
		closeFilters: 'Chiudi filtri',
		openFilters: 'Apri filtri',
		removeFilters: "Rimuovi tutto",
		searchPlaceholder: "Cerca titoli, contenuti di storie e testimonianze.",
		searchPlaceholderMobile: "Cerca titoli, storie...",
		projectsMatch: "I progetti abbinano i tuoi filtri",
		subTechPractices: "Pratiche secondarie",
		subServiceLines: "Sottotipo di attività",
		akkodisCountries: "Paesi",
		certifications: "Certificazioni",
		toolsAndSystems: "Strumenti e sistemi",
		confidentialities: "Riservatezza",
		latest: "Ultimo",
		mostVisited: "Popolare",
		industries: "Industrie",
		techPractices: "Pratiche tecnologiche",
		serviceLines: "Tipo di attività",
		locations: "Posizione della squadra",
		tools: 'Strumenti',
		ftes: "FTEs",
		revenues: "Fatturato",
		clientLocations: "posizione del cliente",
		referenceOwners: "Proprietari di riferimento",
		companies: "Clienti",
		businessContactManagers: "Dirigenti d'impresa",
		deliveryContactManagers: "Responsabili delle consegne",
		filterPlaceholders: {
			location: "Cerca posizione",
			clients: "Cerca clienti",
			tools: "Cerca strumenti",
			certifications: "Cerca le certificazioni",
			owners: "Cerca proprietari di riferimento",
			industries: "Cerca industrie",
			techPractices: 'Cerca pratiche tecniche',
			serviceLines: 'Cerca tipo di attività',
			managers: "Cerca gestore",
			mainClientPersonas: "Cerca le personas dei clienti principali",
			globalOwners: "Cerca proprietari",
			recognitions: "Cerca riconoscimenti",
		},
		recognitions: "Riconoscimenti",
		mainClientPersonas: "Personas dei clienti principali",
		globalOwners: "Proprietario",
		sort: {
			latest: 'ultimo',
			mostVisited: 'più visitato'
		},
		statistics: {
			subTechPractices: 'Pratiche subtecnologiche',
			subServiceLines: 'Sottotipo di attività',
			akkodisCountries: 'Paesi',
			certifications: 'Certificazioni',
			toolsAndSystems: 'Strumenti e sistemi',
			title: ' i progetti corrispondono ai tuoi filtri',
			publishedDateMessage: 'Hai selezionato le date di pubblicazione da',
			saved: 'Salvato',
			filterBySavedProjects: 'Filtra per progetti salvati',
			to: 'a',
			selectDates: 'Filtra per data di pubblicazione',
			datesAlreadyExist: 'Il periodo di tempo esiste già.',
			days: {
				monday: 'Lun',
				tuesday: 'Mar',
				wednesday: 'Mer',
				thursday: 'Gio',
				friday: 'Ven',
				saturday: 'Sab',
				sunday: 'Dom'
			},
			months: {
				january: 'Gen',
				february: 'Feb',
				march: 'Mar',
				april: 'Apr',
				may: 'Mag',
				june: 'Giu',
				july: 'Lug',
				august: 'Ago',
				september: 'Set',
				october: 'Ott',
				november: 'Nov',
				december: 'Dic'
			}
		},
		relevancy: 'Rilevanza',
		clearAllFilters: 'Cancella tutti i filtri',
		saved: 'Salvato',
		draft: "Bozza",
		deliveryLocation: "Luogo di consegna",
	},
	[LANGUAGE.ja.short]: {
		filters: "フィルター",
		unselectAll: 'すべて選択解除',
		noResults: '結果が見つかりませんでした。',
		date: '日付: 全期間',
		selectDateRange: '新しい日付範囲を選択',
		list: 'リスト',
		grid: 'グリッド',
		removeAllFilters: "すべてのフィルターを削除",
		searchInputPlaceHolder: 'すべてのストーリーコンテンツを検索',
		closeFilters: 'フィルターを閉じる',
		openFilters: 'フィルターを開く',
		removeFilters: "すべて削除する",
		searchPlaceholder: "タイトル、ストーリー コンテンツ、お客様の声を検索します。",
		searchPlaceholderMobile: "タイトル、ストーリーを検索...",
		projectsMatch: "プロジェクトはフィルターと一致します",
		subTechPractices: "サブテクノロジープラクティス",
		subServiceLines: "事業のサブタイプ",
		akkodisCountries: "国",
		certifications: "認定",
		toolsAndSystems: "ツールとシステム",
		confidentialities: "機密保持",
		latest: "最新",
		mostVisited: "人気",
		industries: "産業",
		techPractices: "技術慣行",
		serviceLines: "事業の種類",
		locations: "チームの場所",
		tools: 'ツール',
		ftes: "FTEs",
		revenues: "収益",
		clientLocations: "クライアントの場所",
		referenceOwners: "参照所有者",
		companies: "クライアント",
		businessContactManagers: "ビジネスマネージャー",
		deliveryContactManagers: "デリバリーマネージャー",
		filterPlaceholders: {
			location: "場所を検索する",
			clients: "クライアントを検索する",
			tools: "ツールを検索する",
			certifications: "認定を検索する",
			owners: "参照所有者の検索",
			industries: "業界を探す",
			techPractices: '技術慣行を検索する',
			serviceLines: '業種を検索',
			managers: "マネージャーを検索",
			mainClientPersonas: "主要なクライアントのペルソナを検索",
			globalOwners: "オーナーを検索",
			recognitions: "認識を検索",
		},
		recognitions: "認識",
		mainClientPersonas: "主要なクライアントのペルソナ",
		globalOwners: "オーナー",
		sort: {
			latest: '最新',
			mostVisited: '最も訪問された'
		},
		statistics: {
			subTechPractices: 'サブテックの実践',
			subServiceLines: '事業のサブタイプ',
			akkodisCountries: '国',
			certifications: '認定',
			toolsAndSystems: 'ツールとシステム',
			title: ' プロジェクトはあなたのフィルターに一致します',
			publishedDateMessage: 'から出版日を選択しました',
			saved: '保存されました',
			filterBySavedProjects: '保存されたプロジェクトでフィルタリングする',
			to: 'に',
			selectDates: '発行日でフィルタリングする',
			datesAlreadyExist: '期間はすでに存在します。',
			days: {
				monday: '月',
				tuesday: '火',
				wednesday: '水',
				thursday: '木',
				friday: '金',
				saturday: '土',
				sunday: '日'
			},
			months: {
				january: '1月',
				february: '2月',
				march: '行進',
				april: '4月',
				may: '5月',
				june: '六月',
				july: '7月',
				august: '8月',
				september: '9月',
				october: '10月',
				november: '11月',
				december: '12月'
			}
		},
		relevancy: '関連性',
		clearAllFilters: 'すべてのフィルターをクリア',
		saved: '保存された',
		draft: "ドラフト",
		deliveryLocation: "配達場所",
	},
	[LANGUAGE.es.short]: {
		filters: "Filtros",
		unselectAll: 'Deseleccionar todo',
		noResults: 'No se encontraron resultados.',
		date: 'Fecha: Todo el tiempo',
		selectDateRange: 'Selecciona un nuevo rango de fechas',
		list: 'Lista',
		grid: 'Cuadrícula',
		removeAllFilters: "Eliminar todos los filtros",
		searchInputPlaceHolder: 'Buscar en todo el contenido de las historias',
		closeFilters: 'Cerrar filtros',
		openFilters: 'Abrir filtros',
		removeFilters: "Eliminar todo",
		searchPlaceholder: "Buscar títulos, contenido de historias y testimonios.",
		searchPlaceholderMobile: "Buscar títulos, historias...",
		projectsMatch: "Los proyectos coinciden con tus filtros",
		subTechPractices: "Sub prácticas tecnológicas",
		subServiceLines: "Subtipo de negocio",
		akkodisCountries: "Países",
		certifications: "Certificaciones",
		toolsAndSystems: "Herramientas y sistemas",
		confidentialities: "Confidencialidad",
		latest: "Último",
		mostVisited: "Popular",
		industries: "Industrias",
		techPractices: "Prácticas tecnológicas",
		serviceLines: "Tipo de negocio",
		locations: "Ubicación del equipo",
		tools: 'Herramientas',
		ftes: "FTEs",
		revenues: "Ingresos",
		clientLocations: "Ubicación del cliente",
		referenceOwners: "Propietarios de referencia",
		companies: "Clientes",
		businessContactManagers: "Gerentes comerciales",
		deliveryContactManagers: "Gerentes de entrega",
		filterPlaceholders: {
			location: "Buscar ubicación",
			clientes: "Buscar clientes",
			herramientas: "Buscar herramientas",
			certificaciones: "Buscar certificaciones",
			propietarios: "Buscar propietarios de referencia",
			industrias: "Buscar industrias",
			practicasTecnologicas: 'Buscar prácticas tecnológicas',
			lineasDeServicio: 'Buscar líneas de servicio',
			generadores: 'Buscar generadores',
			mainClientPersonas: "Buscar personas de clientes principales",
			globalOwners: "Buscar propietarios",
			recognitions: "Buscar reconocimientos",
		},
		recognitions: "Reconocimientos",
		mainClientPersonas: "Personas de clientes principales",
		globalOwners: "Propietario",
		sort: {
			latest: 'último',
			mostVisited: 'más visitado'
		},
		statistics: {
			subTechPractices: 'Sub prácticas tecnológicas',
			subServiceLines: 'Subtipo de negocio',
			akkodisCountries: 'países',
			certifications: 'Certificaciones',
			toolsAndSystems: 'Herramientas y sistemas',
			title: ' proyectos coinciden con tus filtros',
			publishedDateMessage: 'Has seleccionado fechas de publicación desde',
			saved: 'Guardado',
			filterBySavedProjects: 'Filtrar por proyectos guardados',
			to: 'a',
			selectDates: 'Filtrar por fecha de publicación',
			datesAlreadyExist: 'El período de tiempo ya existe.',
			days: {
				monday: 'Lun',
				tuesday: 'Mar',
				wednesday: 'Mié',
				thursday: 'Jue',
				friday: 'Vie',
				saturday: 'Sáb',
				sunday: 'Dom'
			},
			months: {
				january: 'Ene',
				february: 'Feb',
				march: 'Mar',
				april: 'Abr',
				may: 'May',
				june: 'Jun',
				july: 'Jul',
				august: 'Ago',
				september: 'Sep',
				october: 'Oct',
				november: 'Nov',
				december: 'Dic'
			}
		},
		relevancy: 'Relevancia',
		clearAllFilters: 'Borrar todos los filtros',
		saved: 'Guardado',
		draft: "Borrador",
		deliveryLocation: "Lugar de entrega",
	}
}
